import http from "../http-common"

const getAll = () => {
	return http.get(`/v1/rooms/`)
}

const get = id => {
	return http.get(`/v1/rooms/${id}`)
}

const create = data => {
	return http.post("/v1/rooms", data)
}

const updateGuestCounter = (id, data) => {
	return http.post(`/v1/rooms/guest/counter/${id}`, data)
}
const updateEmployeeCounter = (id, data) => {
	return http.post(`/v1/rooms/employee/counter/${id}`, data)
}
const updateMasterCounter = (id, data) => {
	return http.post(`/v1/rooms/master/counter/${id}`, data)
}

const remove = id => {
	return http.delete(`/v1/rooms/${id}`)
}

const removeAll = () => {
	return http.delete(`/v1/rooms`)
}

export default {
	getAll,
	get,
	create,
	updateGuestCounter,
	updateEmployeeCounter,
	updateMasterCounter,
	remove,
	removeAll,
}
